import BatteryLifecyclePill from '../BatteryLifecyclePill';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { BatteryLifecycleStatus, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BatteryStatusMenu: FunctionComponent<Props> = ({
    className = '',
    lifecycleLabels,
    onSelect,
    statuses,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const definitions: Record<BatteryLifecycleStatus, string> = {
        hold: t.BATTERY_STATUS_DEFINITION_HOLD,
        'in-service': t.BATTERY_STATUS_DEFINITION_IN_SERVICE,
        retired: t.BATTERY_STATUS_DEFINITION_RETIRED
    };

    return (
        <VerticalContainer className={`${styles.batteryStatusMenu} ${className}`} testId={testId}>
            {statuses.map(status => (
                <Wrapper className={styles.menuRow} key={status} onClick={() => onSelect(status)}>
                    <BatteryLifecyclePill label={lifecycleLabels[status]} status={status} />

                    <Wrapper className={styles.definition}>{definitions[status]}</Wrapper>
                </Wrapper>
            ))}
        </VerticalContainer>
    );
};

export default BatteryStatusMenu;
